function setupMap() {
    // Map venir à la clinique
    var map = jQuery('#map');
    if (!map) {
        return;
    }

    var lat = map.data('lat');
    var lng = map.data('lng');
    var icon = map.data('icon');

    map = L.map('map', { zoomControl: false }).setView([lat, lng], 11);
    var show = false;

    var poi = L.icon({
        iconUrl: icon,
        iconSize: [25, 34], // size of the icon
        iconAnchor: [12, 34], // point of the icon which will correspond to marker's location
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png', {
        maxZoom: 20,
        minZoom: 5,
        attribution: ''
    }).addTo(map);

    L.marker([lat, lng], { icon: poi }).addTo(map)
        .on('click', function () {
            if (!show) {
                jQuery('.map-container').addClass('show');
                show = true;
            } else {
                jQuery('.map-container').removeClass('show');
                show = false;

            }
        })
}

function slickJumbo() {
    jQuery('.jumbotron__slides.slick').slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,

    });
}

jQuery(function () {
    // Slick Jumbotron
    jQuery(window).resize(Foundation.util.throttle(function () {
        if (Foundation.MediaQuery.atLeast('large')) {
            slickJumbo();
        }
    }, 500));
    jQuery(window).trigger('resize');

    //
    if (!Foundation.MediaQuery.atLeast('large')) {
        jQuery('.footer .first-menu').on("click", function () {
            jQuery(this).find('ul').slideToggle();
        });
        jQuery('.footer .second-menu').on("click", function () {
            jQuery(this).find('ul').slideToggle();
        });
    }

    // Loading pour les requêtes ajax
    $(document)
        .ajaxStart(function () {
            jQuery('body').addClass('loading');
        })
        .ajaxComplete(function () {
            jQuery('body').removeClass('loading');
        });

    // Retour en haut de page
    jQuery('.bt_top, .top').on('click', function (event) {
        jQuery('body, html').stop().animate({ scrollTop: 0 }, 800);
        event.preventDefault();
    });

    // Map leaflet
    setupMap();

    // Mobile footer menu
    jQuery('.footer-menu__open-menu').click(function () {
        jQuery('.footer-menu__content').toggleClass('show');
        jQuery('.footer-menu__open-menu').toggleClass('opened');
        jQuery(".footer-menu__menu .is-drilldown").removeAttr("style");
        jQuery('.js-drilldown-back a').html("Retour");
    });
    jQuery('.vertical.lateral__menu').attr('data-parent-link', true);

})

// Prérequis pour la mise en place d'Accordeon (balise H2 H3 H4 suivie d'un conteneur "Citations" [balise "blockquote"])
// les title et content doivent avoir une marge à zero pour eviter que l'accordeon sursaute 
jQuery(document).ready(function () {
    var i = 1;
    jQuery('.rte h2, .rte h3, .rte h4').each(function () {
        if ($(this).next().is('blockquote')) {
            jQuery(this).addClass('accordion-title innerAccordeon' + i);
            i++;
        }
    });
    if (i === 1) return;
    i = 1;
    jQuery('.rte blockquote').each(function () {
        jQuery(this).addClass('accordion-content innerAccordeon' + i);
        jQuery(".innerAccordeon" + i).wrapAll("<div class='accordion-item'></div>");
        i++;
    });
    var allPanels = $('.accordion-content').hide();
    jQuery('.accordion-title').on('click', function () {
        if (!$(this).parents('.accordion-item').hasClass('is-active')) {
            allPanels.slideUp();
            jQuery('.accordion-item.is-active').removeClass('is-active');
            jQuery(this).next().slideDown();
            jQuery(this).parents('.accordion-item').addClass('is-active');

        } else {
            jQuery('.accordion-item.is-active').removeClass('is-active');
            jQuery(this).next().slideUp();
            jQuery(this).parents('.accordion-item').removeClass('is-active');
        }
        return false;
    });
});


function masonryTarification() {
    if (typeof Masonry !== 'function') return;
    jQuery('.tarification__items').masonry({
        itemSelector: '.tarification__item',
        horizontalOrder: true,
        transitionDuration: 0,
    });
}

function slickTarification() {
    if (jQuery('.tabs-panel.is-active .tarification__items.slick-slider').length > 0) {
        return;
    }
    jQuery('.tabs-panel.is-active .tarification__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        mobileFirst: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                    arrows: true,
                    autoplay: false
                }
            },
            {
                breakpoint: 860,
                settings: {
                    slidesToShow: 2,
                    dots: false,
                    arrows: true,
                    autoplay: false
                }
            },
            {
                breakpoint: 496,
                settings: {
                    arrows: true,
                    autoplay: false
                }
            }
        ]
    });
}

jQuery(document).ready(function () {
    var mode = jQuery('[data-type="slider"]').length > 0 ? 'slider' : 'masonry';
    $('[data-tabs]').on('change.zf.tabs', function () {
        if (mode == 'masonry') {
            masonryTarification();
        } else {
            slickTarification();
        }
    });
    $('[data-tabs]').trigger('change.zf.tabs');
}); 